import React, { useState } from 'react';
import cn from 'classnames';
import { TagContainer, TagText } from './Tag.style-elements';
import { useStyles } from './Tag.style';

interface TagProps {
  onClick?: (state: boolean) => void;
}

const Tag: React.FC<TagProps> = ({ children, onClick }) => {
  const { selectedClass, selectedTextClass } = useStyles();
  const [isSelected, setIsSelected] = useState<boolean>(false);

  const clickHandler = (): void => {
    if (onClick) onClick(!isSelected);
    setIsSelected(!isSelected);
  };

  return (
    <TagContainer
      onClick={clickHandler}
      className={cn({ [selectedClass]: isSelected })}
    >
      <TagText className={cn({ [selectedTextClass]: isSelected })}>
        {children}
      </TagText>
    </TagContainer>
  );
};

export default Tag;
